import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import type { TreeSelectOption } from "./types";

type ValueType = string | number | Array<string | number> | null;

interface Props {
  modelValue?: ValueType;
  treeData?: TreeSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  showSearch?: boolean;
  treeCheckable?: boolean;
  treeDefaultExpandAll?: boolean;
  multiple?: boolean;
  loading?: boolean;
  maxTagCount?: number | "responsive";
  status?: "" | "error" | "warning";
  treeNodeFilterProp?: string;
  fieldNames?: { label?: string; value?: string; children?: string };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TreeSelect',
  props: {
    modelValue: { default: null },
    treeData: { default: () => [] },
    placeholder: { default: "Chọn..." },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },
    treeCheckable: { type: Boolean, default: false },
    treeDefaultExpandAll: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    maxTagCount: { default: "responsive" },
    status: { default: "" },
    treeNodeFilterProp: { default: "title" },
    fieldNames: { default: () => ({ label: "title", value: "value", children: "children" }) }
  },
  emits: ["update:modelValue", "change", "search"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const mapNode = (node: TreeSelectOption): any => ({
  ...node,
  title: node.title ?? node.label ?? String(node.value),
  value: node.value,
  key: node.key ?? node.value,
  disabled: node.disabled,
  selectable: node.selectable,
  children: node.children?.map(mapNode),
});

const normalizedTree = computed(() => (props.treeData || []).map(mapNode));

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: ValueType) => {
    emit("update:modelValue", val);
  },
});

const onChange = (val: ValueType, label?: any, extra?: any) => {
  emit("update:modelValue", val);
  emit("change", val, label, extra);
};

const onSearch = (val: string) => emit("search", val);

return (_ctx: any,_cache: any) => {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createBlock(_component_a_tree_select, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    "tree-data": normalizedTree.value,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    "show-search": _ctx.showSearch,
    "tree-checkable": _ctx.treeCheckable,
    "tree-default-expand-all": _ctx.treeDefaultExpandAll,
    "tree-node-filter-prop": _ctx.treeNodeFilterProp,
    multiple: _ctx.multiple,
    "max-tag-count": _ctx.maxTagCount,
    status: _ctx.status,
    loading: _ctx.loading,
    "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
    class: "ant-tree-select",
    onChange: onChange,
    onSearch: onSearch
  }, null, 8, ["value", "tree-data", "placeholder", "disabled", "size", "allow-clear", "show-search", "tree-checkable", "tree-default-expand-all", "tree-node-filter-prop", "multiple", "max-tag-count", "status", "loading"]))
}
}

})